import React from 'react';

import { DoctorInfoPanel, PatientInfoPanel } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';
import { TreatmentFullDetail } from 'src/components/treatments/TreatmentFullDetail';

import { withRouter, permissions } from 'src/helpers';

import model from './model';
import filesModel from './filesModel';

const { PAGES } = permissions;

class TreatmentDetail extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    model.on('accountSwitched', this.init);
    this.init();
  }

  init = () => {
    filesModel.setListStateSilent({ items: [], total: 0 }, filesModel.getCurrentId());
    if (this.props.router.params.treatmentId) {
      model.loadDetail(this.props.router.params.treatmentId, (error) => {
        if (error) {
          this.back();
        } else if (!model.state.user?.isPatient) {
          // filesModel.load(model.state.treatment.patient.id, model.state.treatment.doctor.id);
        } else {
          model.loadDoctorDetail(model.state.treatment.doctor.id);
        }
      });
    }
  };

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.cancel('accountSwitched', this.init);
  }

  renderPatient = () => {
    const { treatment } = model.state;
    const { patient } = treatment || {};

    return (
      <div className={'mc-container-content__body-right'}>
        <PatientInfoPanel
          patient={{ ...patient }}
          viewProfile={() => this.navigate(PAGES.PATIENTS_DETAIL_PAGE.match(patient.id))}
          // model={filesModel}
          template={2}
          hideHeader={true}
        />
      </div>
    );
  };
  viewProfile = () => {
    const { treatment } = model.state;
    const { doctor } = treatment || {};
    let url = PAGES.DOCTORS_DETAIL_PAGE.match(doctor.username);
    this.navigate(url);
  };
  renderDoctor = () => {
    const { treatment, user } = model.state;
    const { doctor } = treatment || {};

    if (!doctor) return null;

    return (
      <div
        className={'mc-container-content__body-' + (user?.isClinic ? 'left mc-br-light' : 'right')}
      >
        <DoctorInfoPanel
          {...doctor}
          doctor={doctor}
          hideHeader={true}
          closeBtn={() => this.setState({ hideInfo: true })}
          viewProfile={this.viewProfile}
        />
      </div>
    );
  };

  render() {
    const { treatment } = model.state;
    const { doctor } = treatment || {};

    return (
      <TreatmentFullDetail
        treatment={treatment}
        model={model}
        RightComp={() =>
          !model.state.user?.isPatient && model.state.user?.id !== doctor?.id && this.renderDoctor()
        }
        LeftComp={() => (model.state.user?.isPatient ? this.renderDoctor() : this.renderPatient())}
        onBack={() => this.navigate(-1)}
      />
    );
  }
}

export default withRouter(TreatmentDetail);
